export default "__VITE_ASSET__CzhyhMoD__"